import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { useMediaQuery } from '@/hooks';
import logoImage from '@/images/logo.svg';
import routes from '@/routes';
import { localizedRoute } from '@/utils/locale';

const sizeLg = {
	width: 107,
	height: 32
};

const sizeSm = {
	width: 80,
	height: 24
};

const sizes = {
	default: {
		desktop: sizeLg,
		mobile: sizeSm
	},
	lg: {
		desktop: sizeLg,
		mobile: sizeLg
	},
	sm: {
		desktop: sizeSm,
		mobile: sizeSm
	}
};

function Logo({ size = 'default', className }) {
	const mdDown = useMediaQuery('mdDown');
	const loggedIn = useSelector(state => state.profile.loggedIn);

	const sizesByResolution = sizes[size];
	const sizeData = mdDown
		? sizesByResolution.mobile
		: sizesByResolution.desktop;

	return (
		<Link
			className={className}
			to={loggedIn ? routes.myDocuments : localizedRoute(routes.home)}
		>
			<img
				src={logoImage}
				alt="Logo"
				width={sizeData.width}
				height={sizeData.height}
			/>
		</Link>
	);
}

export default Logo;
